import CheckboxTeaser from "./CheckboxTeaser";

export default CheckboxTeaser;
